export default __webpack_public_path__ + "static/media/debate_3.5b3e930c.JPG";